import FrontPageView from './FrontPageView';
import ImageView from './ImageView';
import ConfigView from './ConfigView';

export {
    ImageView,
    FrontPageView,
    ConfigView
};



// WEBPACK FOOTER //
// ./plugins/HistomicsTK/web_client/views/body/index.js